import {
  AgreementReadinessEditTargetSurface,
  type AgreementReadinessEditTarget,
} from '@urbanx/agx.campaigns.client';

export const resolveReadinessTarget = (
  target: AgreementReadinessEditTarget,
  context: { campaignId: string; proposalId: string }
): { href: string; message?: never } | { href?: never; message: string } => {
  if (target.surface === AgreementReadinessEditTargetSurface.Agreement)
    return { message: 'Complete this in the agreement after an agreement draft is created.' };
  if (!target.formId) return { message: 'No saved preparation form is available for this target.' };
  return {
    href: `/form?${new URLSearchParams({
      campaignId: context.campaignId,
      formId: target.formId,
      proposalId: context.proposalId,
      pageKey: target.pageKey,
    })}`,
  };
};
